var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["./pdp-ship-restriction-icon.j2"] = require( "./pdp-ship-restriction-icon.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["product/templates/shipping/pdp-ship-accordion-header.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "\n<h3 class=\"o-accordion__label c-product-details__label\" data-qa-shipping-accordion>\n\n\t<span class=\"c-product-details__shipping-header js-product-details__shipping-header\">\n\n        ";
output += runtime.suppressValue((lineno = 5, colno = 10, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_shipping-returns"])), env.opts.autoescape);
output += "\n\n    </span>";
if(runtime.contextOrFrameLookup(context, frame, "hasRestrictions")) {
output += "<span class=\"c-shipping-restriction__alert\">\n\n\t        ";
env.getTemplate("./pdp-ship-restriction-icon.j2", false, "product/templates/shipping/pdp-ship-accordion-header.j2", null, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
t_1.render(context.getVariables(), frame, function(t_4,t_2) {
if(t_4) { cb(t_4); return; }
output += t_2
output += "\n\n\t    </span>";
})});
}
output += "</h3>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["product/templates/shipping/pdp-ship-accordion-header.j2"] , dependencies)